import React from 'react';
import styled from 'styled-components';

const SVGC = styled.svg`
  @media (max-width: 530px) {
    width: 100%;
  }
`;
const Logo = ({ color }) => {
  return (
    <SVGC
      width="163"
      height="52"
      viewBox="0 0 163 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="26.1692"
        cy="27.2113"
        rx="21.427"
        ry="21.5218"
        fill="#0B37AA"
      />
      <path
        d="M29.2407 45.8708C35.8825 43.7923 38.0945 39.7956 40.3128 35.3136C42.531 30.8315 41.4144 32.9048 43.5 26.1517C45.1685 20.7493 41.7964 15.902 39.9018 14.1537C38.7236 13.0172 35.3016 10.4435 31.0399 9.24089C26.7781 8.03824 20.3854 9.30114 17.3831 10.7286C15.8724 11.5373 10.5074 12.3245 8.49392 20.232C7.06588 25.8401 7.88571 29.6041 8.01659 31.3904C8.26725 34.8114 12.2907 36.7748 14.2947 39.7608C16.2247 42.6311 22.5226 47.9733 29.2407 45.8708Z"
        fill="#1B4CCA"
      />
      <path
        d="M25.9467 46.7951C32.5317 46.7951 34.0368 44.2658 35.9553 41.9003C39.4434 37.5996 41.528 37.5082 44.85 31.7015C47.1698 27.6466 44.5585 20.8739 43.1614 18.6454C42.3027 17.2127 39.6592 13.7436 35.9553 11.3293C32.2514 8.9151 25.1715 9.2404 22.0945 9.70482C20.5276 10.0246 15.0886 10.522 12.7928 15.0752C10.1064 20.4029 10.1063 23.5927 10.1063 24.6883C10.1063 26.0888 12.9118 31.9525 14.1559 35.3918C15.3552 38.6988 19.2859 46.7951 25.9467 46.7951Z"
        fill="#1E55E2"
      />
      <path
        d="M13.2473 39.0797C16.7689 44.157 23.8594 43.4089 26.9644 42.4002C30.5928 41.7158 29.3925 42.3013 35.3806 40.6715C40.171 39.3675 42.4594 34.285 43.0048 31.9068C43.3813 30.4036 43.9229 26.394 43.0769 22.3807C42.2309 18.3674 37.3734 13.9366 35.0504 12.2229C33.8128 11.4048 30.1553 9.74376 25.426 9.64407C19.5143 9.51946 17.4028 13.7264 17.3579 14.1877C17.322 14.5567 14.4332 20.7931 12.9932 23.8652C11.6106 26.8211 9.72575 34.0024 13.2473 39.0797Z"
        fill="#4173F3"
      />
      <path
        d="M20.0234 43.9235C25.0957 47.0665 31.0886 43.6767 33.451 41.5889C36.4018 39.5871 35.5638 40.5674 40.2411 36.8206C43.983 33.823 44.0552 28.4408 43.6235 26.1244C43.3789 24.6481 42.3164 20.8881 40.0235 17.6585C37.7305 14.429 31.7236 12.3725 29.0067 11.748C27.5958 11.4993 23.7172 11.4347 19.4896 13.1654C14.2052 15.3288 14.0905 19.8457 14.0905 20.2933C14.0905 21.1738 14.0404 27.2693 13.9465 30.5443C13.8587 33.6945 14.9512 40.7805 20.0234 43.9235Z"
        fill="#7399FA"
      />
      <path
        d="M18.627 42.0623C22.9086 45.7018 28.9513 43.3704 31.4374 41.7497C34.4588 40.2911 33.5436 41.0899 38.4123 38.2422C42.3072 35.964 43.1198 30.9493 43.0392 28.7267C43.0162 27.3144 42.5489 23.6564 40.8639 20.3225C39.1789 16.9886 33.8775 14.2335 31.4374 13.2727C30.1598 12.8444 26.5618 12.2447 22.3906 13.2727C17.1767 14.5576 16.3135 18.7597 16.3825 19.1764C16.4378 19.5098 15.3697 25.6822 14.8288 28.7267C14.3108 31.6554 14.3453 38.4228 18.627 42.0623Z"
        fill="#B0C6FF"
      />
      <path
        d="M61.7969 15.3827H72.5312V19.5255H66.5538V24.9333H72.0618V29.171H66.5538V37.2985H61.7969V15.3827Z"
        fill={color || 'white'}
      />
      <path
        d="M82.5558 15.3827H87.2501V31.9539C87.2501 33.6827 86.6972 35.0637 85.5914 36.0967C84.5065 37.1087 82.8896 37.6147 80.7406 37.6147C78.6125 37.6147 76.9956 37.1087 75.8898 36.0967C74.8049 35.0848 74.2625 33.7038 74.2625 31.9539V15.3827H78.9568V31.7009C78.9568 32.7551 79.5514 33.2822 80.7406 33.2822C81.9507 33.2822 82.5558 32.7551 82.5558 31.7009V15.3827Z"
        fill={color || 'white'}
      />
      <path
        d="M89.9139 15.3827H94.6708V33.3138H100.46V37.2985H89.9139V15.3827Z"
        fill={color || 'white'}
      />
      <path
        d="M101.703 20.5691C101.703 18.8825 102.277 17.5754 103.425 16.6477C104.593 15.699 106.346 15.2246 108.682 15.2246C110.226 15.2246 111.541 15.3722 112.626 15.6674V20.0315C111.457 19.6731 110.299 19.4939 109.152 19.4939C108.025 19.4939 107.295 19.6309 106.961 19.905C106.627 20.158 106.46 20.5375 106.46 21.0435V31.6693C106.46 32.6813 107.243 33.1873 108.807 33.1873C110.393 33.1873 111.697 33.0292 112.719 32.7129V36.9822C111.593 37.2985 110.226 37.4566 108.62 37.4566C106.283 37.4566 104.541 36.9928 103.393 36.0651C102.267 35.1375 101.703 33.8303 101.703 32.1437V20.5691Z"
        fill={color || 'white'}
      />
      <path
        d="M119.608 29.3924V37.2985H114.914V15.3827H121.986C123.697 15.3827 125.032 15.7938 125.992 16.6161C126.952 17.4383 127.432 18.64 127.432 20.2213V24.2692C127.432 26.7992 126.576 28.3804 124.865 29.0129L128.277 37.2985H123.113L120.202 29.3924H119.608ZM119.608 19.4307V25.6291H121.454C121.934 25.6291 122.268 25.5236 122.456 25.3128C122.643 25.102 122.737 24.733 122.737 24.206V20.6324C122.737 20.1686 122.633 19.8523 122.424 19.6837C122.216 19.515 121.892 19.4307 121.454 19.4307H119.608Z"
        fill={color || 'white'}
      />
      <path
        d="M138.148 15.3827H142.842V31.9539C142.842 33.6827 142.289 35.0637 141.184 36.0967C140.099 37.1087 138.482 37.6147 136.333 37.6147C134.205 37.6147 132.588 37.1087 131.482 36.0967C130.397 35.0848 129.855 33.7038 129.855 31.9539V15.3827H134.549V31.7009C134.549 32.7551 135.144 33.2822 136.333 33.2822C137.543 33.2822 138.148 32.7551 138.148 31.7009V15.3827Z"
        fill={color || 'white'}
      />
      <path
        d="M163 15.3827V37.2985H158.462V29.677C158.462 27.4844 158.661 25.3233 159.057 23.194L156.053 31.7326H152.422L149.418 23.194C149.814 25.1547 150.013 27.3157 150.013 29.677V37.2985H145.506V15.3827H150.326L154.237 26.5778L158.149 15.3827H163Z"
        fill={color || 'white'}
      />
    </SVGC>
  );
};
export default Logo;
